import { styled } from "@pigment-css/react";
import { Pill } from "@acto/taskpane/field-sales-2/components/primitives/Pill";
import { glassCapsulePress } from "@acto/taskpane/field-sales-2/styles/glassCapsulePress";
import { pressInteraction } from "@acto/taskpane/field-sales-2/styles/pressInteraction";

// Sticky bottom bar in the BottomNavShell style (top-fading gradient + pointer-events
// passthrough). `marginTop: auto` pins it to the bottom when content is short; the top
// padding keeps space above the button when the content nearly fills the sheet.
export const CtaRow = styled("div")(({ theme }) => ({
  position: "sticky",
  bottom: 0,
  zIndex: 2,
  marginTop: "auto",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.fieldSalesTwo.spacing[16],
  padding: `${theme.fieldSalesTwo.spacing[24]} ${theme.fieldSalesTwo.spacing[16]} ${theme.fieldSalesTwo.spacing[32]}`,
  background: `linear-gradient(to top, ${theme.fieldSalesTwo.colors.background} 26.5%, rgba(240,238,237,0))`,
  pointerEvents: "none",
  "& > *": { pointerEvents: "auto" },
}));

export const SolidCtaButton = styled("button")(({ theme }) => ({
  width: "100%",
  minHeight: 52,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box",
  paddingInline: theme.fieldSalesTwo.spacing[20],
  border: `${theme.strokeWidth.thin} solid ${theme.fieldSalesTwo.colors.surface.glassBorder}`,
  borderRadius: theme.fieldSalesTwo.radius[38],
  background: theme.fieldSalesTwo.colors.accent.action,
  color: theme.fieldSalesTwo.colors.neutral[50],
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size[15],
  fontWeight: theme.fieldSalesTwo.font.weight[520],
  letterSpacing: theme.fieldSalesTwo.font.letterSpacing.subtle,
  cursor: "pointer",
  WebkitTapHighlightColor: "transparent",
  transition: "filter 120ms ease, transform 120ms ease",
  ...pressInteraction(theme),
  // Darken slightly on hover; pressInteraction supplies the press shrink + ring.
  "&:hover": { filter: "brightness(0.93)" },
  "&:disabled": { opacity: 0.5, pointerEvents: "none" },
}));

export const SheetCtaButton = styled(Pill)(({ theme }) => ({
  gap: theme.fieldSalesTwo.spacing[8],
  color: theme.fieldSalesTwo.colors.neutral[900],
  boxShadow: theme.fieldSalesTwo.shadows.glass,
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size[14],
  fontWeight: theme.fieldSalesTwo.font.weight[500],
  lineHeight: theme.fieldSalesTwo.font.lineHeight[168],
  cursor: "pointer",
  whiteSpace: "nowrap",
  appearance: "none",
  WebkitAppearance: "none",
  ...glassCapsulePress(theme, { restShadow: theme.fieldSalesTwo.shadows.glass }),
  "&:disabled": {
    opacity: 0.5,
    pointerEvents: "none",
  },
}));
